import type { Product } from '@frontend/libs/types/product'

import { __ } from '@wordpress/i18n'

import ProductSlider from '../product-slider/ProductSlider'

export interface ProductSliderProps {
  products: Product[]
}

export function RelatedProductSlider({
  products,
}: Readonly<ProductSliderProps>) {
  return (
    <section className="my-16 grid grid-cols-1 overflow-hidden">
      <ProductSlider
        products={products}
        title={__('You may also like', 'asavagroup')}
      />
    </section>
  )
}

export default RelatedProductSlider
